/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

export const PathWrapper = styled.div({
  alignItems: 'center',
  alignSelf: 'center',
  display: 'flex',
  flexGrow: 1,
  flexWrap: 'wrap',
  marginLeft: `${gridSize() / 2}px`,
});
